/*
 * Module for handling the list of reports in the report page.
 * This is basically the same as the list for sub groups.
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/reportSplit/groups/groupView",
  "modules/reportSplit/reports/reportModel",
  "modules/reportSplit/groups/groupList/groupListModule",
  "modules/reportSplit/groups/groupTiles/groupTilesModule",
  "modules/reportSplit/groups/adHocWorkbooks/adHocWorkbooksModule",
], function (
  Marionette,
  Messenger,
  GroupView,
  ReportModel,
  GroupListModule,
  GroupTilesModule,
  AdHocWorkbooksModule,
) {
  var GroupController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "reportGroupModule";
      this.region = options.region;
      this._setUpVents();
    },
    show: function () {
      this.groups = Messenger.reqres.request("report:groups");

      this.layout = new GroupView.groupLayout();

      //sub module creation
      this.groupList = this.addSubModule(new GroupListModule({ region: this.layout.groupList }));
      this.groupDiv = this.addSubModule(new GroupTilesModule({ region: this.layout.groupDiv }));
      this.adHocWorkbooks = this.addSubModule(
        new AdHocWorkbooksModule({ region: this.layout.workbookDiv }),
      );

      this.layout.on(
        "show",
        function () {
          this._showSubViews(this.groups);
        },
        this,
      );

      this.showRegion(this.layout, { loading: true });
    },
    _showSubViews: function (groups) {
      this.groupList.show(groups);
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "show:report:tiles",
        function () {
          this.layout.showTiles();
        },
        this,
      );
      Messenger.vent.on(
        "hide:report:tiles",
        function () {
          this.layout.hideTiles();
        },
        this,
      );
    },
  });

  return GroupController;
});
